import { initLivePreview } from "./src/lib/contentstack-live";

initLivePreview();
